import { render, staticRenderFns } from "./qrcode.vue?vue&type=template&id=12db296c&scoped=true&"
import script from "./qrcode.vue?vue&type=script&lang=js&"
export * from "./qrcode.vue?vue&type=script&lang=js&"
import style0 from "./qrcode.vue?vue&type=style&index=0&id=12db296c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12db296c",
  null
  
)

export default component.exports